var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 430,
    viewBox: "0 0 433 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M430.25 195.507C218.81 198.075 47.4948 386.138 0.354126 429.84L25.0325 0.336842C161.675 108.758 348.613 195.309 430.25 195.507C431.083 195.497 431.917 195.49 432.752 195.485C431.929 195.502 431.095 195.509 430.25 195.507Z",
    fill: "url(#paint0_linear_300_90750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.692 195.569C216.429 198.734 71.7599 281.845 25.0339 325.163L18.3112 66.1831C151.948 172.22 339.99 195.641 424.692 195.569C427.369 195.528 430.056 195.501 432.753 195.487C430.183 195.538 427.494 195.566 424.692 195.569Z",
    fill: "url(#paint1_linear_300_90750)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0339 325.163C72.3604 281.289 220.163 196.591 432.753 195.487C352.491 197.1 156.369 175.727 18.3112 66.1831L25.0339 325.163Z",
    stroke: "url(#paint2_linear_300_90750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_90750",
    x1: 18.4178,
    y1: 194.747,
    x2: 432.752,
    y2: 194.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E2F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_90750",
    x1: 18.4178,
    y1: 194.747,
    x2: 575.311,
    y2: 195.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDFF6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DA2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_90750",
    x1: 18.4188,
    y1: 195.955,
    x2: 432.752,
    y2: 194.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF1DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.c130d55c0f147a6f1348a053f3fce211.svg";
export { ForwardRef as ReactComponent };